import React, { useState } from "react";
import { ANGLE_ARROW, BUILD } from "../../assets";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";

const aboutCategories = [
  {
    label: "Our Purpose",
    content:
      "We aim to provide every citizen, investor, and stakeholder with easy, digital access to court-filed litigation on properties across Anambra State. By ensuring transparency and reducing the risks of disputed transactions, we are building trust in the land and housing market.",
    tags: [
      "Verified litigation updates",
      "Fast certificate downloads",
      "Reliable records",
    ],
  },
  {
    label: "Our Mandate",
    content:
      "Lis Pendens Anambra is mandated to digitize and centralize access to court-recognized property litigation records. We collaborate with the Anambra State Judiciary and relevant institutions to ensure data accuracy, integrity, and timeliness. Our system is built to protect due diligence processes, encourage safe transactions, and support legal accountability.",
    tags: [
      "Judiciary-backed data integrity",
      "Centralized, transparent records",
      " Secure upload and update by registrars",
    ],
  },
  {
    label: "Our Impact",
    content:
      "By streamlining access to lis pendens records, we're reducing transaction fraud, promoting public confidence in land dealings, and equipping legal and real estate professionals with reliable data. Our work supports property rights, judicial transparency, and the broader goal of a trustworthy land registry system.",
    tags: [
      " Reduced property fraud risk",
      "Increased buyer and investor confidence",
      "Support for transparent legal systems",
    ],
  },
];
function AboutUs() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();
  return (
    <div
      id="about"
      className="lg:px-20 px-5 lg:flex-row flex-col w-full py-10 flex items-start justify-between lg:space-x-10"
    >
      <div className="flex flex-col gap-y-5 ">
        <div className="w-fit px-5 py-3 font-medium rounded-full text-globalGold text-[16px] bg-lightGold">
          <span>About Us</span>
        </div>
        <span className="font-bold text-[32px] text-black">
          We provide legal clarity for property transactions
        </span>
        <span className="text-[16px] font-medium text-[#333333]">
          Welcome to Lis Pendens Anambra. Backed by the Anambra State Judiciary,
          we provide verified information on land-related litigations to protect
          buyers, investors, and stakeholders. Our goal is to digitize access to
          court-filed property disputes for smarter, safer transactions.
        </span>
        <div className="w-full flex items-center bg-[#F7F7F7]">
          {aboutCategories.map((item, idx) => (
            <div
              onClick={() => setSelectedIndex(idx)}
              className={clsx(
                "cursor-pointer  py-4 w-full flex items-center justify-center text-sm font-medium",
                selectedIndex === idx &&
                  "bg-lightGold text-[16px] text-globalGold border-t-[2px]  border-globalGold"
              )}
            >
              {item.label}
            </div>
          ))}
        </div>
        <span className="text-[16px] font-medium text-[#333333]">
          {aboutCategories[selectedIndex].content}
        </span>

        <div className="flex lg:items-center justify-between items-start gap-y-4 lg:flex-row  flex-col">
          {aboutCategories[selectedIndex].tags.map((item) => (
            <div className="flex items-center gap-2">
              <div className="w-[14px] h-[14px] rotate-45 bg-globalGold" />
              <span className="text-sm font-medium text-[#333333]">{item}</span>
            </div>
          ))}
        </div>
        <button
          onClick={() => navigate("/search")}
          className="w-fit hover:scale-95 transition-all duration-300 bg-globalGold px-5 py-2 rounded-3xl flex items-center justify-center gap-x-2"
        >
          <span className="text-[16px] font-medium text-white">
            Start Your Search
          </span>
          <img src={ANGLE_ARROW} className="w-[20px] h-[20px]" alt="" />
        </button>
      </div>
      <img src={BUILD} className="lg:w-[389px] w-full h-[452px]" alt="" />
    </div>
  );
}

export default AboutUs;
